var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"f-editable-table__cell-selection-region",style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }